import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "verify-vs-enrich",
  courseId: "reports-from-audio",
  order: 4,
  title: "Verify vs enrich",
  summary:
    "Footage analysis has two modes. Verify checks your draft against what the camera saw. Enrich writes the camera's observations into the draft.",
  learn: [
    "Choose the right mode for the report",
    "Know what each mode changes in the editor",
    "Decide when to read every minute of the video",
  ],
  minutes: 3,
  releasedAt: "2026-09-24T00:00:00.000Z",
  gate: "video",
  sceneId: "verify-vs-enrich",
  tourId: "verify-vs-enrich",
  body: [
    {
      type: "paragraph",
      text: "With the footage add-on, the AI does not just hear the video, it watches it. Frames are pulled at one per second (more where there is motion) and reviewed on contact sheets to find the moments that matter. Those windows are then read closely. The result is a timestamped event log, and the mode you pick at upload decides how the log is used.",
    },
    {
      type: "steps",
      items: [
        "In the upload modal, find the video row and turn on **Analyze the footage**.",
        "Choose \"Check the draft against the footage\" (verify) or \"Write footage observations into the draft\" (enrich).",
        "Tick \"Read every minute…\" if the whole recording matters.",
        "Upload as usual.",
      ],
    },
    {
      type: "paragraph",
      text: "Without \"Read every minute…\", the close read is limited to the flagged windows, up to about 40 percent of the video. **Keep original video file** is forced on.",
    },
    { type: "heading", text: "Verify" },
    {
      type: "paragraph",
      text: "The narrative drafts from the audio as normal. When the footage finishes, discrepancies and omissions are posted as suggestions prefixed \"[Footage check\": a time that does not match, a person the camera shows who the narrative never mentions, an object on the ground. They re-run every time you regenerate.",
    },
    { type: "heading", text: "Enrich" },
    {
      type: "paragraph",
      text: "The draft waits for the event log, and the writer is given the visual observations as body-camera facts. The narrative comes out with what was seen, not only what was said. Expect it to take longer, because the draft cannot start until the footage pass is done.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Verify is the safe default. Your words stay yours and the camera becomes a second reviewer. Use enrich when you have little or no narration and need the footage to carry the report.",
    },
    {
      type: "callout",
      tone: "note",
      text: "The model is instructed never to identify people from their appearance. Events describe actions, objects, and positions, and cite the second they were seen.",
    },
    {
      type: "paragraph",
      text: "\"The Footage tab\" shows how to review the event log once the analysis finishes.",
    },
  ],
  related: ["the-footage-tab", "body-cam-footage"],
};

export default lesson;
